import { render, staticRenderFns } from "./darfor-darfor-att-for-att.vue?vue&type=template&id=291babc4&scoped=true"
import script from "./darfor-darfor-att-for-att.vue?vue&type=script&lang=js"
export * from "./darfor-darfor-att-for-att.vue?vue&type=script&lang=js"
import style0 from "./darfor-darfor-att-for-att.vue?vue&type=style&index=0&id=291babc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291babc4",
  null
  
)

export default component.exports